"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clear = clear;
exports.get = get;
exports.remove = remove;
exports.set = set;

var _Logger = _interopRequireDefault(require("./Logger"));

function get(name) {
  if (!name) {
    _Logger["default"].error("Name (".concat(name, ") is necessary values for this function to work"));

    return undefined;
  }

  return sessionStorage.getItem(name);
}

function set(name, value) {
  if (!name) {
    _Logger["default"].error("Name (".concat(name, ") is necessary values for this function to work"));

    return;
  }

  if (!value || value === '') {
    sessionStorage.removeItem('name');
    return;
  }

  sessionStorage.setItem(name, value);
  window.dispatchEvent(new StorageEvent('storage', {
    key: name,
    newValue: value
  }));
}

function remove(name) {
  if (!name) {
    _Logger["default"].error("Name (".concat(name, ") is necessary values for this function to work"));

    return;
  }

  sessionStorage.removeItem(name);
  window.dispatchEvent(new StorageEvent('storage', {
    key: name,
    newValue: undefined
  }));
}

function clear() {
  sessionStorage.clear();
  window.dispatchEvent(new StorageEvent('storage'));
}